import { Card, Col, Form, message, Row, Collapse } from "antd";

import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import axios from "services/axiosB2C";
import { RequestToken } from "../../../../services/b2c";

const FormItem = Form.Item;

class CustomerDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
    };
  }

  componentDidMount() {
    this.getCustomerDetail(this.props.match.params.id);
  }

  async getCustomerDetail(id) {
    try {
      let token = await RequestToken();
      axios
        .get(`/users/${id}`, {
          headers: {
            Authorization: token,
          },
        })
        .then(result => {
          this.setState({ user: result.data.user });
        })
        .catch(err => {
          message.error("Gagal request data customer car");
        });
    } catch (e) {
      message.error("Gagal request data customer car");
    }
  }

  render() {
    const { user } = this.state;
    return user.id ? (
      <Card title="Customer Car">
        <div id="CustomerDetail">
          <Row>
            <Col xs={24} md={12}>
              <Card title="EMAIL MEMBER">
                <span className="ant-form-text form-text-mod">
                  {user.email}
                </span>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="HARI/TGL DIBUAT">
                <span className="ant-form-text form-text-mod">
                  {moment(user.created_at).format("dddd, D MMMM YYYY HH:mm")}
                </span>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12}>
              <Card title="PROFILE CUSTOMER">
                <FormItem label="Nama Lengkap">
                  <span className="ant-form-text form-text-mod">
                    {user.userprofile ? user.userprofile.name : ""}
                  </span>
                </FormItem>
                <FormItem label="No. HP">
                  <span className="ant-form-text form-text-mod">
                    {user.userprofile ? user.userprofile.phone : ""}
                  </span>
                </FormItem>
                <FormItem label="Jenis Kelamin">
                  <span className="ant-form-text form-text-mod">
                    {user.userprofile
                      ? user.userprofile.gender
                        ? user.userprofile.gender === "L"
                          ? "Laki-laki"
                          : "Perempuan"
                        : ""
                      : ""}
                  </span>
                </FormItem>
                <FormItem label="Tempat Lahir">
                  <span className="ant-form-text form-text-mod">
                    {user.userprofile ? user.userprofile.place_of_birth : ""}
                  </span>
                </FormItem>
                <FormItem label="Tanggal Lahir">
                  <span className="ant-form-text form-text-mod">
                    {user.userprofile
                      ? user.userprofile.date_of_birth
                        ? moment(user.userprofile.date_of_birth).format(
                            "dddd, D MMMM YYYY"
                          )
                        : ""
                      : ""}
                  </span>
                </FormItem>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="DATA MOBIL CUSTOMER">
                <FormItem label="List Mobil">
                  {user.customercars && user.customercars.length > 0 ? (
                    user.customercars.map((v, i) => (
                      <Row>
                        <Collapse ghost>
                          <Collapse.Panel
                            header={`${v.brand} ${v.spec} ${v.year}`}
                            key={i}>
                            <Col xs={24} md={12}>
                              <FormItem label="Brand">
                                <span className="ant-form-text form-text-mod">
                                  {v.brand}
                                </span>
                              </FormItem>
                              <FormItem label="Model">
                                <span className="ant-form-text form-text-mod">
                                  {v.type}
                                </span>
                              </FormItem>
                              <FormItem label="Tipe">
                                <span
                                  className="ant-form-text form-text-mod"
                                  style={{ lineHeight: "30px" }}>
                                  {v.spec}
                                </span>
                              </FormItem>
                              <FormItem label="Tahun">
                                <span className="ant-form-text form-text-mod">
                                  {v.year}
                                </span>
                              </FormItem>
                            </Col>
                            <Col xs={24} md={12}>
                              <FormItem label="Warna">
                                <span className="ant-form-text form-text-mod">
                                  {v.color}
                                </span>
                              </FormItem>
                              <FormItem label="Nomor Polisi">
                                <span className="ant-form-text form-text-mod">
                                  {v.license_plate}
                                </span>
                              </FormItem>
                              <FormItem label="Nomor Rangka">
                                <span className="ant-form-text form-text-mod">
                                  {v.engine_number}
                                </span>
                              </FormItem>
                              <FormItem label="Tahun STNK">
                                <span className="ant-form-text form-text-mod">
                                  {moment(v.stnk_term).format("YYYY-MM-DD")}
                                </span>
                              </FormItem>
                            </Col>
                          </Collapse.Panel>
                        </Collapse>
                      </Row>
                    ))
                  ) : (
                    <span className="ant-form-text form-text-mod">
                      TIDAK ADA{" "}
                    </span>
                  )}
                </FormItem>
              </Card>
            </Col>
          </Row>
        </div>
      </Card>
    ) : null;
  }
}

export default CustomerDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/B2C/Customer/CustomerDetail.js